import React, { useState } from "react";
import {
  GlobeAmericasIcon,
  BookmarkIcon,
  UsersIcon,
  CheckIcon,
} from "@heroicons/react/24/solid";

interface TripFiltersProps {
  activeFilter: "all" | "my" | "shared";
  onChange: (filter: "all" | "my" | "shared") => void;
  isSelectionMode?: boolean;
  selectedTrips?: string[];
}

const TripFilters: React.FC<TripFiltersProps> = ({
  activeFilter,
  onChange,
  isSelectionMode = false,
  selectedTrips = [],
}) => {
  const filters: {
    id: "all" | "my" | "shared";
    label: string;
    icon: React.ReactNode;
  }[] = [
    {
      id: "all",
      label: "All Trips",
      icon: <GlobeAmericasIcon className="w-4 h-4" />,
    },
    { id: "my", label: "My Trips", icon: <BookmarkIcon className="w-4 h-4" /> },
    {
      id: "shared",
      label: "Shared with Me",
      icon: <UsersIcon className="w-4 h-4" />,
    },
  ];

  return (
    <div className="flex flex-row w-full justify-start items-center min-h-16">
      <div className="flex flex-row space-x-2">
        {filters.map((filter) => (
          <button
            key={filter.id}
            onClick={() => onChange(filter.id)}
            className={`flex items-center space-x-2 px-3 py-2 text-sm font-medium rounded-full transition ease-in-out duration-300 ${
              activeFilter === filter.id
                ? "bg-indigo-800 text-white"
                : "bg-indigo-50 text-indigo-600 hover:bg-indigo-200 hover:text-indigo-800 hover:shadow-sm"
            }`}
          >
            {filter.icon}
            <span>{filter.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TripFilters;
